import { CheckIcon, XIcon } from "lucide-react";
import { COMPARISON } from "../data/content";
export function Comparison() {
  return <section className="px-5 pt-10" data-id="element-45" data-mp="1g9clct5qrubh">
      <h2 className="text-center text-2xl font-black text-blue-950" data-id="element-46" data-mp="1g68876aato8o">
        Sin el kit <span className="text-gray-400" data-id="element-47" data-mp="1l5umzk5rzcjl">vs.</span> Con el kit
      </h2>

      {/* Cuadro compacto: ambas planillas visibles sin scroll */}
      <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-48" data-mp="1ux7f8cvhk4q5">
        {/* Sin el kit */}
        <div className="rounded-2xl border border-red-200 bg-red-50/70 p-3" data-id="element-49" data-mp="1uzbe2gej2djk">
          <p className="mb-2 flex items-center gap-1.5 text-xs font-extrabold uppercase text-red-600" data-id="element-50" data-mp="1zuqpz2sz5zdc">
            <XIcon size={14} data-id="element-51" data-mp="23yf2lzwgrl5g" /> Sin el Kit
          </p>
          <ul className="space-y-2" data-id="element-52" data-mp="28xi4jbh5db97">
            {COMPARISON.without.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-53" data-mp="9k4a9hgnu8ux">
                <XIcon size={13} className="mt-0.5 flex-shrink-0 text-red-400" data-id="element-54" data-mp="9lp4f5z2bps9" />
                <span className="text-[11px] leading-tight text-gray-700" data-id="element-55" data-mp="1m0gy2ft3m428">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Con el kit */}
        <div className="rounded-2xl border border-green-300 bg-green-50 p-3 shadow-sm" data-id="element-56" data-mp="1d85i5nvm1z0i">
          <p className="mb-2 flex items-center gap-1.5 text-xs font-extrabold uppercase text-green-700" data-id="element-57" data-mp="189ap7t3xiu2o">
            <CheckIcon size={14} data-id="element-58" data-mp="24zbcfnonh2hv" /> Con el Kit
          </p>
          <ul className="space-y-2" data-id="element-59" data-mp="24ys5t34ga0j5">
            {COMPARISON.with.map(t => <li key={t} className="flex items-start gap-1.5" data-id="element-60" data-mp="20zax80tq8n9r">
                <CheckIcon size={13} className="mt-0.5 flex-shrink-0 text-green-600" data-id="element-61" data-mp="1vydi5x40k9ch" />
                <span className="text-[11px] leading-tight text-gray-800" data-id="element-62" data-mp="1qzabk88dxv2e">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}